// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"specific-quote_quoteContainer_2IU9r","startQuote":"specific-quote_startQuote_3fXpa","endQuote":"specific-quote_endQuote_2jnnC"};